import { render, staticRenderFns } from "./register.vue?vue&type=template&id=72674514&scoped=true&"
import script from "./register.vue?vue&type=script&lang=ts&"
export * from "./register.vue?vue&type=script&lang=ts&"
import style0 from "./register.vue?vue&type=style&index=0&id=72674514&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72674514",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/zfh/dev/targus-micor/targus-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('72674514')) {
      api.createRecord('72674514', component.options)
    } else {
      api.reload('72674514', component.options)
    }
    module.hot.accept("./register.vue?vue&type=template&id=72674514&scoped=true&", function () {
      api.rerender('72674514', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/home/modules/userAccount/register.vue"
export default component.exports